<!-- <div *ngIf="this.loader.getLoading()" class="cssload-container">
    <span class="loader"></span>
</div> -->

<div *ngIf="this.loader.getLoading()" class="cssload-container">
    <span class="loader"></span>
</div>